import PropTypes from 'prop-types';

import BookmarkerApp from 'hb-react/frontoffice/components/bookmarks/BookmarkerApp';

const Bookmark = ({ user, onChange }) => (
  <div className="absolute icon-size--150 palm--icon-size--200 north east soft-eighth">
    <BookmarkerApp
      bookmarkable={user}
      bookmarkable_type="User"
      onChange={onChange}
    />
  </div>
);

Bookmark.propTypes = {
  user: PropTypes.object.isRequired,
  onChange: PropTypes.func,
};

export default Bookmark;
